import React, { useState, useEffect } from "react";
import { NavLink, Redirect } from "react-router-dom";
import auth from "../providers/Auth.Provider";
import Image from "./Image";
import { EventEmitter } from "../event/EventEmitter";
import { EVENT_TARGET } from "../event/model";
import { toast } from "react-toastify";

const Navigation = ({ history }) => {
  const _top_key = "top_list";
  const { GetToken } = auth.authProvider;
  const staff = auth.authProvider.GetAuthenticatedStaff();
  const [message, setMessage] = useState([]);
  const [search, setSearch] = useState();
  const [newMessage, setNewMessage] = useState();

  EventEmitter.subscribe(EVENT_TARGET.Top_Notify, (msg) => {
    const _items = [...message];
    _items.push(msg);
    localStorage.setItem(_top_key, JSON.stringify(_items));
    setNewMessage(msg);
  });
  EventEmitter.subscribe(EVENT_TARGET.Clear_Top_Notify, () => {
    // localStorage.removeItem(_top_key);
    localStorage.setItem(_top_key, JSON.stringify([]));
    setMessage([]);
  });

  useEffect(() => {
    const _item = localStorage.getItem(_top_key);
    setMessage(JSON.parse(_item));
  }, [newMessage, setMessage]);

  if (!GetToken()) {
    return <Redirect to="/login" />;
  }

  return (
    <div id="nav-bar1" className="page-header navbar fixed-top">
      <div className="page-header-inner flex-nav">
        {/* <!-- logo start --> */}
        <div className="page-logo" style={{ width: "300px" }}>
          <NavLink to="/home/clinical-note/ward-summary">
            <img width="36" alt="logo" src="/assets/img/logo.jpeg" />
            <span
              className="logo-default"
              style={{
                paddingLeft: "5px",
                color: "#333333",
              }}
            >
              Clinicalspec
            </span>
          </NavLink>
        </div>
        {/* <!-- logo end --> */}
        {/* <!-- start header menu --> */}
        <div className="scroll-message">
          <div className="scroll-left">
            <p style={{ color: "#044ab8" }}>{message && message.join(" | ")}</p>
          </div>
        </div>
        <div className="search-menu">
          <form
            className="form-inline w-100"
            onSubmit={(event) => {
              event.preventDefault();
              if (search) history.push(`/home/clinical-note/search/${search}`);
              else
                toast.warn("Please enter a value!", {
                  position: "top-right",
                });
            }}
          >
            <input
              className="form-control w-100"
              type="search"
              onChange={({ target: { value } }) => setSearch(value)}
              placeholder="Search"
              aria-label="Search"
            />
          </form>
        </div>

        <div className="top-menu">
          <ul className="nav navbar-nav">
            {/* <!-- start manage user dropdown --> */}
            <li className="dropdown dropdown-user">
              <a
                href="(javascript):;"
                className="dropdown-toggle"
                data-toggle="dropdown"
                data-hover="dropdown"
                data-close-others="true"
              >
                <Image
                  src={staff.image}
                  alt={staff.name}
                  height={25}
                  width={25}
                />
              </a>
              <ul className="dropdown-menu drop-in">
                <li>
                  <NavLink
                    to={{
                      pathname: `/home/staffing/profile`,
                      state: { activeStaff: staff },
                      search: `?ref=${staff.id}`,
                    }}
                  >
                    <i className="fa fa-user"></i> Your Profile
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={{
                      pathname: "/home/staffing/profile/setting",
                      search: `?ref=${staff.id}`,
                    }}
                  >
                    <i className="fa fa-cog"></i> Settings
                  </NavLink>
                </li>
                <li>
                  <a
                    onClick={() => {
                      if (window.confirm("Are you sure you want to logout?")) {
                        auth.authProvider.LogOut();
                        document.location.reload(true);
                      }
                    }}
                    href="#"
                  >
                    <i className="fa fa-sign-out"></i> Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="nav navbar-nav in">
            {/* <!-- start full screen button --> */}
            <li>
              <NavLink
                to="/home/clinical-note/ward-summary"
                className="app-list-icon font-size-20"
              >
                <i className="fa fa-home"></i>
              </NavLink>
            </li>
            <li>
              <a
                href="(javascript):;"
                className="app-list-icon fullscreen-click font-size-20"
              >
                <i className="fa fa-arrows-alt"></i>
              </a>
            </li>
            {/* <!-- end full screen button --> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
